import { WarrantsAccountState } from "@/models/admin/warrantsAccount/warrantsAccount.types"
import {
  FilterRadio,
  FilterType,
  SoDataTableFilters,
} from "@/types/components/SoDataTable"
import { sentenceCase } from "@/helpers/stringHelpers"

// One radio option per warrants_account_state, e.g. 'Warrant phase first'.
export const statusOptions: Record<string, string> = Object.values(
  WarrantsAccountState,
).reduce(
  (options, state) => {
    options[state] = sentenceCase(state)
    return options
  },
  {} as Record<string, string>,
)

export const pausedOptions: Record<string, string> = {
  true: "Paused",
  false: "Not paused",
}

export interface WarrantsAccountsTableFilters extends SoDataTableFilters {
  status: FilterRadio<WarrantsAccountState>
  paused: FilterRadio<"true" | "false">
}

export const warrantsAccountsTableFilters: WarrantsAccountsTableFilters = {
  status: {
    type: FilterType.RADIO,
    label: "Status",
    value: null,
    options: statusOptions,
    expandable: true,
  },
  paused: {
    type: FilterType.RADIO,
    label: "Paused",
    value: null,
    options: pausedOptions,
    expandable: true,
  },
}
